;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .factory('JobOutcomePolicyFactory', [
      '$http',
      'UserService',
      JobOutcomePolicyFactory
    ])
  function JobOutcomePolicyFactory($http, UserService) {
    var factory = {
      getJobOutcomePolicy: getJobOutcomePolicy,
      getJobOutcomePolicyByAppId: getJobOutcomePolicyByAppId,
      deleteJobOutcomePolicy: deleteJobOutcomePolicy,

      // jenkins
      getJenkinsJobOutcomePolicy: getJenkinsJobOutcomePolicy,
      addJobOutcomePolicy: addJobOutcomePolicy,
      refreshJenkinsJobOutcomePolicy: refreshJenkinsJobOutcomePolicy,
      editJenkinsJobOutcomePolicy: editJenkinsJobOutcomePolicy,
      refreshExistingJenkinsJobOutcomePolicy:
        refreshExistingJenkinsJobOutcomePolicy
    }

    return factory

    // JOP
    function getJobOutcomePolicy() {
      return $http.get(UserService.buildAPIUrl('/jobOutcomePolicies/'))
    }

    function getJobOutcomePolicyByAppId(appId) {
      return $http.get(UserService.buildAPIUrl('/jobOutcomePolicies/' + appId))
    }

    function deleteJobOutcomePolicy(id) {
      return $http['delete'](
        UserService.buildAPIUrl('/jobOutcomePolicies/' + id)
      )
    }

    function addJobOutcomePolicy(jobOutcomePolicies) {
      return $http.post(
        UserService.buildAPIUrl('/jobOutcomePolicies/'),
        jobOutcomePolicies
      )
    }

    function getJenkinsJobOutcomePolicy(id) {
      return $http.get(UserService.buildAPIUrl('/jobOutcomePolicies/' + id))
    }

    //Jenkins JOP

    function refreshJenkinsJobOutcomePolicy(jobOutcomePolicies) {
      return $http.post(
        UserService.buildAPIUrl('/jobOutcomePolicies/refresh'),
        jobOutcomePolicies
      )
    }

    function editJenkinsJobOutcomePolicy(id, jobOutcomePolicies) {
      return $http.put(
        UserService.buildAPIUrl('/jobOutcomePolicies/' + id),
        jobOutcomePolicies
      )
    }

    function refreshExistingJenkinsJobOutcomePolicy(id, jobOutcomePolicies) {
      return $http.post(
        UserService.buildAPIUrl('/jobOutcomePolicies/' + id + '/refresh'),
        jobOutcomePolicies
      )
    }
  }
})()
